module.exports = __webpack_public_path__ + "images/2x6-billboard-0431041ae6034e422d06a9b38689d943.jpg";